module.exports = "\n<app-promo></app-promo>\n<app-file></app-file>\n<app-form></app-form>\n"